var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lob-button",class:[
		{ small: _vm.small },
		_vm.theme
	]},[(_vm.left && _vm.icon)?_c('font-awesome-icon',{staticClass:"lob-button__icon left",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v("\n\n\t"+_vm._s(_vm.text)+"\n\n\t"),(_vm.right && _vm.icon)?_c('font-awesome-icon',{staticClass:"lob-button__icon right",attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }